import { useState, useEffect } from 'react';
import fb from '~/api/core/facebook';

function useCustomAudiences(accountId, accessToken, fields = 'name,id') {
  const [audiences, setAudiences] = useState([]);
  const [pickedAudiences, setPickedAudiences] = useState(null);

  useEffect(() => {
    if (accessToken && accountId) {
      const path = `${accountId}/customaudiences`;
      fb(path, 'GET', { accessToken, fields })
        .then(e => setAudiences(e.data));
      setPickedAudiences(null);
    }
  }, [accountId, accessToken, fields]);


  return { pickedAudiences, setPickedAudiences, audiences };
}

export default useCustomAudiences;
